import { render, staticRenderFns } from "./InspectionForm.vue?vue&type=template&id=22a1de0e"
import script from "./InspectionForm.vue?vue&type=script&lang=js"
export * from "./InspectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports